// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_e8-a";
export var fulfillmentFormRail = "_e8-9";
export var headerTitleRow = "_e8-c";
export var orderDetailsWrapper = "_e8-7";
export var orderLinkTrigger = "_e8-2";
export var paymentInformationGrid = "_e8-h";
export var paymentSummaryColumn = "_e8-i";
export var shipmentContainer = "_e8-b";
export var shipmentDetailsMainPane = "_e8-8";
export var shipmentNavigationCard = "_e8-5";
export var shipmentNavigationRail = "_e8-3";
export var shipmentNavigationRailHeader = "_e8-4";
export var shipmentSummaryFact = "_e8-e";
export var shipmentSummaryGrid = "_e8-d";
export var shipmentSummaryMetadataRow = "_e8-f";
export var shipmentSummaryTags = "_e8-g";
export var shipmentWorkspace = "_e8-0";
export var shipmentWorkspaceContent = "_e8-6";
export var shipmentWorkspaceHeader = "_e8-1";